export const REDUCER_KEY = 'chat';
